import { default as http } from "../rest/http";
import { DEFAULT_ROLE_OPTIONS, DEFAULT_STATUS_OPTIONS } from "../constants/globalSearch";

export interface GlobalSearchParams {
  page: number;
  per_page: number;
  searchText: string;
  selection: string;
  role?: string[];
  userStatus?: string[];
  organizationId?: string[];
}

export const fetchGlobalSearchResults = async (params: GlobalSearchParams) => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", params.page.toString());
  queryParams.append("per_page", params.per_page.toString());
  queryParams.append("searchText", params.searchText);
  queryParams.append("selection", params.selection);
  params.role?.forEach((r) => queryParams.append("role", r));
  params.userStatus?.forEach((s) => queryParams.append("userStatus", s));
  params.organizationId?.forEach((o) => queryParams.append("organizationId", o));
  const url = `/master-data/global-search?${queryParams.toString()}`;
  const response = await http.get(url);
  return response;
};

export const fetchSearchFilterOptions = async () => {
  try {
    const response = await http.get("/master-data/global-search/filters");
    return response;
  } catch {
    return {
      roles: DEFAULT_ROLE_OPTIONS,
      statuses: DEFAULT_STATUS_OPTIONS,
      organizations: [],
    };
  }
};
